// AUTO-GENERATED by scripts/gen-destinations.mjs — do not edit by hand.
// Source: visamundi-website/content/destinations/registry.ts
// Maps ISO 3166-1 alpha-2 → visamundi.co destination slugs per locale.
export const DESTINATION_SLUGS = {
  "al": {
    "fr": "albanie",
    "en": "albania",
    "de": "albanien",
    "it": "albania",
    "es": "albania"
  },
  "ao": {
    "fr": "angola",
    "en": "angola",
    "de": "angola",
    "it": "angola",
    "es": "angola"
  },
  "sa": {
    "fr": "arabie-saoudite",
    "en": "saudi-arabia",
    "de": "saudi-arabien",
    "it": "arabia-saudita",
    "es": "arabia-saudi"
  },
  "am": {
    "fr": "armenie",
    "en": "armenia",
    "de": "armenien",
    "it": "armenia",
    "es": "armenia"
  },
  "au": {
    "fr": "australie",
    "en": "australia",
    "de": "australien",
    "it": "australia",
    "es": "australia"
  },
  "az": {
    "fr": "azerbaidjan",
    "en": "azerbaijan",
    "de": "aserbaidschan",
    "it": "azerbaijan",
    "es": "azerbaiyan"
  },
  "bh": {
    "fr": "bahrein",
    "en": "bahrain",
    "de": "bahrain",
    "it": "bahrein",
    "es": "bahrein"
  },
  "bj": {
    "fr": "benin",
    "en": "benin",
    "de": "benin",
    "it": "benin",
    "es": "benin"
  },
  "br": {
    "fr": "bresil",
    "en": "brazil",
    "de": "brasilien",
    "it": "brasile",
    "es": "brasil"
  },
  "kh": {
    "fr": "cambodge",
    "en": "cambodia",
    "de": "kambodscha",
    "it": "cambogia",
    "es": "camboya"
  },
  "cm": {
    "fr": "cameroun",
    "en": "cameroon",
    "de": "kamerun",
    "it": "camerun",
    "es": "camerun"
  },
  "ca": {
    "fr": "canada",
    "en": "canada",
    "de": "kanada",
    "it": "canada",
    "es": "canada"
  },
  "cv": {
    "fr": "cap-vert",
    "en": "cape-verde",
    "de": "kap-verde",
    "it": "capo-verde",
    "es": "cabo-verde"
  },
  "cn": {
    "fr": "chine",
    "en": "china",
    "de": "china",
    "it": "cina",
    "es": "china"
  },
  "co": {
    "fr": "colombie",
    "en": "colombia",
    "de": "kolumbien",
    "it": "colombia",
    "es": "colombia"
  },
  "kr": {
    "fr": "coree-du-sud",
    "en": "south-korea",
    "de": "sudkorea",
    "it": "corea-del-sud",
    "es": "corea-del-sur"
  },
  "ci": {
    "fr": "cote-d-ivoire",
    "en": "ivory-coast",
    "de": "elfenbeinkuste",
    "it": "costa-davorio",
    "es": "costa-de-marfil"
  },
  "dj": {
    "fr": "djibouti",
    "en": "djibouti",
    "de": "dschibuti",
    "it": "gibuti",
    "es": "djibouti"
  },
  "eg": {
    "fr": "egypte",
    "en": "egypt",
    "de": "agypten",
    "it": "egitto",
    "es": "egipto"
  },
  "et": {
    "fr": "ethiopie",
    "en": "ethiopia",
    "de": "athiopien",
    "it": "etiopia",
    "es": "etiopia"
  },
  "eu": {
    "fr": "europe",
    "en": "europe",
    "de": "europa",
    "it": "europa",
    "es": "europa"
  },
  "fr": {
    "fr": "france",
    "en": "france",
    "de": "frankreich",
    "it": "francia",
    "es": "francia"
  },
  "gs": {
    "fr": "georgie-du-sud-et-les-iles-sandwich-du-sud",
    "en": "south-georgia",
    "de": "sudgeorgien-und-die-sudlichen-sandwichinseln",
    "it": "georgia-del-sud-e-isole-sandwich-meridionali",
    "es": "islas-georgias-del-sur-y-sandwich-del-sur"
  },
  "gd": {
    "fr": "grenade",
    "en": "grenada",
    "de": "grenada",
    "it": "grenada",
    "es": "grenada"
  },
  "gn": {
    "fr": "guinee",
    "en": "guinea",
    "de": "guinea",
    "it": "guinea",
    "es": "guinea"
  },
  "gq": {
    "fr": "guinee-equatoriale",
    "en": "equatorial-guinea",
    "de": "aquatorialguinea",
    "it": "guinea-equatoriale",
    "es": "guinea-ecuatorial"
  },
  "in": {
    "fr": "inde",
    "en": "india",
    "de": "indien",
    "it": "india",
    "es": "india"
  },
  "id": {
    "fr": "indonesie",
    "en": "indonesia",
    "de": "indonesien",
    "it": "indonesia",
    "es": "indonesia"
  },
  "il": {
    "fr": "israel",
    "en": "israel",
    "de": "israel",
    "it": "israele",
    "es": "israel"
  },
  "jp": {
    "fr": "japon",
    "en": "japan",
    "de": "japan",
    "it": "giappone",
    "es": "japon"
  },
  "jo": {
    "fr": "jordanie",
    "en": "jordan",
    "de": "jordanien",
    "it": "giordania",
    "es": "jordania"
  },
  "ke": {
    "fr": "kenya",
    "en": "kenya",
    "de": "kenia",
    "it": "kenya",
    "es": "kenia"
  },
  "kg": {
    "fr": "kirghizistan",
    "en": "kyrgyzstan",
    "de": "kirgisistan",
    "it": "kirghizistan",
    "es": "kirguizistan"
  },
  "la": {
    "fr": "laos",
    "en": "laos",
    "de": "laos",
    "it": "laos",
    "es": "laos"
  },
  "ly": {
    "fr": "libye",
    "en": "libya",
    "de": "libyen",
    "it": "libia",
    "es": "libia"
  },
  "mg": {
    "fr": "madagascar",
    "en": "madagascar",
    "de": "madagascar",
    "it": "madagascar",
    "es": "madagascar"
  },
  "my": {
    "fr": "malaisie",
    "en": "malaysia",
    "de": "malaysia",
    "it": "malesia",
    "es": "malasia"
  },
  "mw": {
    "fr": "malawi",
    "en": "malawi",
    "de": "malawi",
    "it": "malawi",
    "es": "malawi"
  },
  "mr": {
    "fr": "mauritanie",
    "en": "mauritania",
    "de": "mauretanien",
    "it": "mauritania",
    "es": "mauritania"
  },
  "ma": {
    "fr": "maroc",
    "en": "morocco",
    "de": "marokko",
    "it": "marocco",
    "es": "marruecos"
  },
  "mn": {
    "fr": "mongolie",
    "en": "mongolia",
    "de": "mongolei",
    "it": "mongolia",
    "es": "mongolia"
  },
  "mz": {
    "fr": "mozambique",
    "en": "mozambique",
    "de": "mosambik",
    "it": "mozambico",
    "es": "mozambique"
  },
  "mm": {
    "fr": "myanmar",
    "en": "myanmar",
    "de": "myanmar",
    "it": "birmania",
    "es": "myanmar"
  },
  "na": {
    "fr": "namibie",
    "en": "namibia",
    "de": "namibia",
    "it": "namibia",
    "es": "namibia"
  },
  "np": {
    "fr": "nepal",
    "en": "nepal",
    "de": "nepal",
    "it": "nepal",
    "es": "nepal"
  },
  "ng": {
    "fr": "nigeria",
    "en": "nigeria",
    "de": "nigeria",
    "it": "nigeria",
    "es": "nigeria"
  },
  "nz": {
    "fr": "nouvelle-zelande",
    "en": "new-zealand",
    "de": "neuseeland",
    "it": "nuova-zelanda",
    "es": "nueva-zelanda"
  },
  "om": {
    "fr": "oman",
    "en": "oman",
    "de": "oman",
    "it": "oman",
    "es": "oman"
  },
  "ug": {
    "fr": "ouganda",
    "en": "uganda",
    "de": "uganda",
    "it": "uganda",
    "es": "uganda"
  },
  "uz": {
    "fr": "ouzbekistan",
    "en": "uzbekistan",
    "de": "usbekistan",
    "it": "uzbekistan",
    "es": "uzbekistan"
  },
  "pg": {
    "fr": "papouasie-nouvelle-guinee",
    "en": "papua-new-guinea",
    "de": "papua-neuguinea",
    "it": "papua-nuova-guinea",
    "es": "papua-nueva-guinea"
  },
  "ph": {
    "fr": "philippines",
    "en": "philippines",
    "de": "philippinen",
    "it": "filippine",
    "es": "filipinas"
  },
  "do": {
    "fr": "republique-dominicaine",
    "en": "dominican-republic",
    "de": "dominikanische-republik",
    "it": "repubblica-dominicana",
    "es": "republica-dominicana"
  },
  "gb": {
    "fr": "royaume-uni",
    "en": "united-kingdom",
    "de": "vereinigtes-konigreich",
    "it": "regno-unito",
    "es": "reino-unido"
  },
  "ru": {
    "fr": "russie",
    "en": "russia",
    "de": "russland",
    "it": "russia",
    "es": "rusia"
  },
  "rw": {
    "fr": "rwanda",
    "en": "rwanda",
    "de": "ruanda",
    "it": "ruanda",
    "es": "ruanda"
  },
  "sc": {
    "fr": "seychelles",
    "en": "seychelles",
    "de": "seychellen",
    "it": "seychelles",
    "es": "seychelles"
  },
  "sl": {
    "fr": "sierra-leone",
    "en": "sierra-leone",
    "de": "sierra-leone",
    "it": "sierra-leone",
    "es": "sierra-leone"
  },
  "sg": {
    "fr": "singapour",
    "en": "singapore",
    "de": "singapur",
    "it": "singapore",
    "es": "singapur"
  },
  "sx": {
    "fr": "sint-maarten",
    "en": "sint-maarten",
    "de": "sint-maarten",
    "it": "sint-maarten",
    "es": "sint-maarten"
  },
  "lk": {
    "fr": "sri-lanka",
    "en": "sri-lanka",
    "de": "sri-lanka",
    "it": "sri-lanka",
    "es": "sri-lanka"
  },
  "tz": {
    "fr": "tanzanie",
    "en": "tanzania",
    "de": "tansania",
    "it": "tanzania",
    "es": "tanzania"
  },
  "td": {
    "fr": "tchad",
    "en": "chad",
    "de": "tschad",
    "it": "ciad",
    "es": "chad"
  },
  "th": {
    "fr": "thailande",
    "en": "thailand",
    "de": "thailand",
    "it": "tailandia",
    "es": "tailandia"
  },
  "tg": {
    "fr": "togo",
    "en": "togo",
    "de": "togo",
    "it": "togo",
    "es": "togo"
  },
  "tt": {
    "fr": "trinite-et-tobago",
    "en": "trinidad-and-tobago",
    "de": "trinidad-und-tobago",
    "it": "trinidad-e-tobago",
    "es": "trinidad-y-tobago"
  },
  "us": {
    "fr": "usa",
    "en": "united-states",
    "de": "vereinigte-staaten",
    "it": "stati-uniti-damerica",
    "es": "estados-unidos"
  },
  "vn": {
    "fr": "vietnam",
    "en": "vietnam",
    "de": "vietnam",
    "it": "vietnam",
    "es": "vietnam"
  },
  "zm": {
    "fr": "zambie",
    "en": "zambia",
    "de": "sambia",
    "it": "zambia",
    "es": "zambia"
  }
};
